import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import TextLink from 'components/Luxkit/TextLink'
import React, { useContext } from 'react'
import CarHireLocationModal from '../CarHireLocationModal'
import ModalContext from 'contexts/ModalContext'

interface Props {
  offer: App.CarHireOffer;
}

function CarHireOfferTileLocation(props: Props) {
  const { offer } = props
  const sameLocation = offer.pickUp.name === offer.dropOff.name
  const showModal = useContext(ModalContext)

  const onLocationModalClick = (openTab: 'Pick-up' | 'Drop-off') => {
    showModal(<CarHireLocationModal
      offer={offer}
      pickUpLocation={offer.pickUp}
      dropOffLocation={offer.dropOff}
      openTab={openTab}
    />)
  }

  return (
    <BodyTextBlock variant="medium" startIcon={<LineMapMarkerIcon />}>
      {sameLocation && <>Pick-up & Drop-off at <TextLink onClick={() => onLocationModalClick('Pick-up')}>{offer.pickUp.name}</TextLink></>}
      {!sameLocation && <>
        <div>
          Pick up at{' '}
          <TextLink onClick={() => onLocationModalClick('Pick-up')}>{offer.pickUp.name}</TextLink>{' '}
        </div>
        <div>
          Drop-off at{' '}
          <TextLink onClick={() => onLocationModalClick('Drop-off')}>{offer.dropOff.name}</TextLink>
        </div>
      </>}
    </BodyTextBlock>
  )
}

export default CarHireOfferTileLocation
